import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import HyperLayout from '../components/HyperLayout';
import HeroSection from '../components/HeroSection';
import MarkdownRenderer from '../components/MarkdownRenderer';

const CardTerms: React.FC = () => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch('/docs/cards-terms.md');
        const text = await response.text();
        setContent(text);
      } catch (error) {
        console.error('Error loading card terms:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <HyperLayout>
      <Helmet>
        <title>Card Terms and Conditions | BasedApp</title>
        <meta name="description" content="Terms and conditions for using the BasedApp Debit Card, including eligibility, fees, and usage guidelines." />
      </Helmet>
      <HeroSection className="h-[300px]">
        <div className="max-w-screen-xl mt-auto mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-center text-white mb-6">Card Terms and Conditions</h1>
          <p className="text-xl text-white text-center max-w-3xl mx-auto mb-16">
            Terms and conditions for using the BasedApp Debit Card.
          </p>
        </div>
      </HeroSection>
      <div className="min-h-screen bg-black">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
          <div className="space-y-6 text-white text-sm leading-relaxed">
            {loading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              </div>
            ) : (
              <div className="prose prose-sm max-w-none prose-invert prose-headings:text-white prose-headings:font-semibold prose-h2:text-2xl prose-h2:mb-4 prose-p:text-white prose-p:mb-4 prose-li:text-white prose-strong:text-white prose-a:text-primary prose-a:hover:underline">
                <MarkdownRenderer content={content} />
              </div>
            )}
          </div>
        </div>
      </div>
    </HyperLayout>
  );
};

export default CardTerms;